import NextButton from '../Buttons/NextButton/NextButton';
import './CardFooter.css';

function CardFooter(props:{
    button?: string,
    buttonTitle?: string,
    note?: string,
    changeState: () => void
}){
    return (
        <div className='card-footer df fdc aic jcsb'>
            {props.button && <NextButton buttonTitle={props.buttonTitle} onClick={props.changeState} disabled={false}/>}
            {props.note && <p className='note'>{props.note}</p>}
        </div>
    )
}

export default CardFooter;